import { createI18n } from 'vue-i18n';
import { en } from '@/i18n/messages/en.js';
import { bs } from '@/i18n/messages/bs.js';
import { quranEn } from '@/i18n/messages/quran.en.js';
import { quranBs } from '@/i18n/messages/quran.bs.js';
import { de } from '@/i18n/messages/de.js';
import { nl } from '@/i18n/messages/nl.js';
import { fr } from '@/i18n/messages/fr.js';
import { quranDe } from '@/i18n/messages/quran.de.js';
import { quranNl } from '@/i18n/messages/quran.nl.js';
import { quranFr } from '@/i18n/messages/quran.fr.js';
import { studyEn } from '@/i18n/messages/study.en.js';
import { studyBs } from '@/i18n/messages/study.bs.js';
import { studyDe } from '@/i18n/messages/study.de.js';
import { studyNl } from '@/i18n/messages/study.nl.js';
import { studyFr } from '@/i18n/messages/study.fr.js';
import { QURAN_LOCALES } from '@/utils/quran/locale';

const DEFAULT_LOCALE = 'en';
const STORAGE_KEY = 'deenly:locale';

function getInitialLocale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (QURAN_LOCALES.includes(saved)) return saved;

  const nav = (navigator?.language || '').toLowerCase().slice(0, 2);
  return QURAN_LOCALES.includes(nav) ? nav : DEFAULT_LOCALE;
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    en: { ...en, quran: quranEn, study: studyEn },
    bs: { ...bs, quran: quranBs, study: studyBs },
    de: { ...de, quran: quranDe, study: studyDe },
    nl: { ...nl, quran: quranNl, study: studyNl },
    fr: { ...fr, quran: quranFr, study: studyFr },
  },
  pluralRules: {
    // Bosnian: 1, 21, 31… take the singular ("21 ajet"), everything else the
    // plural ("2 ajeta", "11 ajeta"). With three forms the first is zero.
    bs(choice, choicesLength) {
      const singular = choice % 10 === 1 && choice % 100 !== 11;
      if (choicesLength === 3) return choice === 0 ? 0 : singular ? 1 : 2;
      return singular ? 0 : 1;
    },
  },
});

export function setLocale(locale) {
  if (!QURAN_LOCALES.includes(locale)) return;
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
  localStorage.setItem(STORAGE_KEY, locale);
}

